// MyContextProvider.js

import React, { createContext, useEffect, useState } from 'react';
// import { KAKAO_JS_KEY } from '../assets/datas/CommonDatas';
import { IScreen } from './Interfaces';
import { useToast } from '@chakra-ui/react';

const ScreenContext = createContext(null);

const ScreenProvider = ({ children }) => {
  const toast = useToast();
  const KAKAO_JSKey = process.env.REACT_APP_KAKAO_JS_KEY || 'f810dbffcc94c50036f8617a763b8a5e';
  const [windowState, setWindowState] = useState<IScreen>({
    width: window.innerWidth,
    height: window.innerHeight,
    style: window.innerWidth >= 1024 ? "pc" : window.innerWidth <= 500 ? "mobile" : "tablet",
    angle: 0,
    orientation: "portrait",
  });

  useEffect(() => {
    window.Kakao.init(KAKAO_JSKey);
    window.addEventListener('resize', handleChange);
    // 페이지 로드 시 방향을 확인
    window.addEventListener("load", handleChange);
    // 방향 변경 이벤트를 감지
    window.addEventListener("orientationchange", handleChange);
    // window.screen.orientation.addEventListener("change", () => handleRotate("change"));

    return () => {
      window.removeEventListener('resize', handleChange);
      window.removeEventListener('load', handleChange);
      window.removeEventListener('orientationchange', handleChange);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = () => {
    const screenWidth = window.innerWidth;
    let containerStyle = "";
    if (screenWidth > 1024) {
      containerStyle = "pc";
    } else if (screenWidth < 768) {
      containerStyle = "mobile";
    } else {
      containerStyle = "tablet";
    }

    const orient = window.screen.orientation;
    // console.log(orient);

    setWindowState({
      width: window.innerWidth,
      height: window.innerHeight,
      style: containerStyle,
      angle: orient.angle,
      orientation: orient.type.split("-")[0],
    });
  };

  return (
    <ScreenContext.Provider value={windowState}>
      {children}
    </ScreenContext.Provider>
  );
};

export {ScreenProvider, ScreenContext};
